<template>
    <div>
        <el-card class="box-card">
            <div class="title">修改训练数据</div>
            <el-form :model="TrainingDataChange" ref="TrainingDataChangeRef" label-width="135px" class="mt15">
              <el-card shadow="always" class="box-card-sub">
                <el-form-item label="屈光状态" class="speed">
                    <el-select v-model="TrainingDataChange.Diopterstate" placeholder="" style="width: 100%">
                      <el-option label="正视" value="6"></el-option>
                      <el-option label="远视" value="2"></el-option>
                      <el-option label="近视" value="1"></el-option>
                      <el-option label="散光" value="7"></el-option>
                      <el-option label="老花" value="3"></el-option>
                      <el-option label="屈光参差" value="8"></el-option>
                      <el-option label="远视性弱视" value="9"></el-option>
                      <el-option label="散光性弱视" value="10"></el-option>
                      <el-option label="近视性弱视" value="11"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="右眼球镜" class="addAdminForm">
                    <el-input v-model="TrainingDataChange.Righteyedegree" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="左眼球镜" class="addAdminForm">
                    <el-input v-model="TrainingDataChange.Lefteyedegree" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="右眼柱镜" class="addAdminForm">
                    <el-input v-model="TrainingDataChange.Rightcolumnmirror" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="左眼柱镜" class="addAdminForm">
                    <el-input v-model="TrainingDataChange.Leftcolumnmirror" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="ADD" class="speed">
                  <el-select v-model="TrainingDataChange.Addtype" placeholder="" style="width: 100%">
                    <el-option label="0.00D" value="0"></el-option>
                    <el-option label="0.50D" value="1"></el-option>
                    <el-option label="0.75D" value="2"></el-option>
                    <el-option label="1.00D" value="3"></el-option>
                    <el-option label="1.25D" value="4"></el-option>
                    <el-option label="1.50D" value="5"></el-option>
                    <el-option label="1.75D" value="6"></el-option>
                    <el-option label="2.00D" value="7"></el-option>
                    <el-option label="2.25D" value="8"></el-option>
                    <el-option label="2.50D" value="9"></el-option>
                    <el-option label="2.75D" value="10"></el-option>
                    <el-option label="3.00D" value="11"></el-option>
                    <el-option label="3.25D" value="12"></el-option>
                    <el-option label="3.50D" value="13"></el-option>
                    <el-option label="3.75D" value="14"></el-option>
                    <el-option label="4.00D" value="15"></el-option>
                    <el-option label="4.25D" value="16"></el-option>
                    <el-option label="4.50D" value="17"></el-option>
                    <el-option label="4.75D" value="18"></el-option>
                    <el-option label="5.00D" value="19"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="内置透镜规格(右眼)" class="speed">
                  <el-select v-model="TrainingDataChange.Neizhitjggright" placeholder="" style="width: 100%">
                    <el-option
                      v-for="item in neizhitjgglist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="内置透镜规格(左眼)" class="speed">
                  <el-select v-model="TrainingDataChange.Neizhitjggleft" placeholder="" style="width: 100%">
                    <el-option
                      v-for="item in neizhitjgglist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-card>
              <el-card shadow="always" class="box-card-sub">
                <el-form-item label="当前训练区间上限" class="addAdminForm">
                    <el-input v-model="TrainingDataChange.Currangeup" placeholder="" disabled></el-input>
                </el-form-item>
                <el-form-item label="当前训练区间下限" class="addAdminForm">
                    <el-input v-model="TrainingDataChange.Currangelow" placeholder="" disabled></el-input>
                </el-form-item>
                <el-form-item label="当前训练次数" class="addAdminForm">
                    <el-input v-model="TrainingDataChange.Curnum" placeholder="" disabled></el-input>
                </el-form-item>
                <el-form-item label="当前训练速度" class="addAdminForm">
                    <el-input v-model="TrainingDataChange.Curspeed" placeholder="" disabled></el-input>
                </el-form-item>
              </el-card>
              <el-card shadow="always" class="box-card-sub">
                <el-form-item label="人工训练数据包" class="addAdminForm">
                    <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="TrainingDataChange.Rengongdata" disabled></el-input>
                    <el-button type="success" plain @click="clickedit">编辑</el-button>
                </el-form-item>
                <el-form-item label="是否激活人工训练" class="addAdminForm">
                  <el-select v-model="TrainingDataChange.Rengongstate" placeholder="" style="width: 100%">
                    <el-option label="否" value="1"></el-option>
                    <el-option label="是" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-card>
              <el-card shadow="always" class="box-card-sub">
                <el-form-item label="定制训练区间上限" class="addAdminForm">
                    <el-input v-model="TrainingDataChange.Dzrangeup" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="定制训练区间下限" class="addAdminForm">
                    <el-input v-model="TrainingDataChange.Dzrangelow" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="定制训练次数" class="addAdminForm">
                    <el-input v-model="TrainingDataChange.Dznum" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="定制训练速度" class="addAdminForm">
                    <el-input v-model="TrainingDataChange.Dzspeed" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="定制状态" class="speed">
                  <el-select v-model="TrainingDataChange.Dzstate" placeholder="" style="width: 100%">
                    <el-option label="否" value="1"></el-option>
                    <el-option label="是" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-card>
              <el-card shadow="always" class="box-card-sub">
                <el-form-item label="眼睛训练模式" class="speed">
                  <el-select v-model="TrainingDataChange.Eyemode" placeholder="" style="width: 100%">
                    <el-option label="双眼" value="1"></el-option>
                    <el-option label="左眼" value="2"></el-option>
                    <el-option label="右眼" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="规则训练模式" class="speed">
                    <el-select v-model="TrainingDataChange.Xunlianmode" placeholder="" style="width: 100%">
                        <el-option label="基础版" value="1"></el-option>
                        <el-option label="升级版" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="TrainingDataChange.Xunlianmode == 2" label="近点训练值" class="speed">
                  <el-select v-model="TrainingDataChange.Xunlianneardegree" placeholder="" style="width: 100%">
                    <el-option
                      v-for="item in xunlianneardegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="TrainingDataChange.Xunlianmode == 2" label="远点训练值" class="speed">
                  <el-select v-model="TrainingDataChange.Xunlianfardegree" placeholder="" style="width: 100%">
                    <el-option
                      v-for="item in xunlianfardegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-card>
              <el-card shadow="always" class="box-card-sub">
                <el-form-item label="7天训练建议个性化" class="speed">
                    <el-select v-model="TrainingDataChange.Minirulestatus" placeholder="" style="width: 100%">
                        <el-option label="关闭" value="1"></el-option>
                        <el-option label="开启" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="7天训练建议N" class="addAdminForm">
                    <el-input v-model="TrainingDataChange.Minirulen" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="7天训练建议X" class="addAdminForm">
                    <el-input v-model="TrainingDataChange.Minirulex" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="7天训练建议H1" class="addAdminForm">
                    <el-input v-model="TrainingDataChange.Miniruleh1" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="7天训练建议H2" class="addAdminForm">
                    <el-input v-model="TrainingDataChange.Miniruleh2" placeholder=""></el-input>
                </el-form-item>
              </el-card>
              <el-card shadow="always" class="box-card-sub">
                <el-form-item label="备注" class="addAdminForm">
                    <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="TrainingDataChange.Beizhu"></el-input>
                </el-form-item>
              </el-card>
                <el-form-item class="mt20">
                    <el-button type="primary" @click="clicksave">保存</el-button>
                    <el-button type="info" @click="backTrainingData">返回</el-button>
                </el-form-item>
            </el-form>

            <div class="title">备注记录</div>
            <!-- 列表 -->
            <el-table :data="trainingData" border stripe class="mt15">
                <el-table-column prop="Beizhu" label="备注"></el-table-column>
                <el-table-column prop="Adminname" label="操作人员"></el-table-column>
                <el-table-column prop="Createtime" label="操作时间"></el-table-column>
            </el-table>

        </el-card>

        <!-- 6.0人工数据编辑框 -->
        <el-dialog title="编辑人工数据" :visible.sync="Rengongdialog60" width="60%" height="60%" :close-on-click-modal="false">
          <div class="rengongdata1">
            <div class="rengongdata2" v-for="rgitem in Rengongdialog60list" :key="rgitem.index" v-if="rgitem.index >= 0">
              <el-select v-model="rgitem.rangeUp" placeholder="" style="width: 15%" class="rengongdata3">
                <el-option
                  v-for="item in qujianlist60" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="rgitem.rangeLow" placeholder="" style="width: 15%" class="rengongdata3">
                <el-option
                  v-for="item in qujianlist60" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="rgitem.speed" placeholder="" style="width: 15%" class="rengongdata3">
                <el-option
                  v-for="item in speedlist" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="rgitem.num" placeholder="" style="width: 15%" class="rengongdata3">
                <el-option
                  v-for="item in numlist" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-button type="text" @click="clickadd60(rgitem)">增加</el-button>
              <el-button v-if="rgitem.index > 0" type="text" @click="clickdelete60(rgitem)">删除</el-button>
            </div>
          </div>
          <el-button type="primary" @click="clicksave60">保存</el-button>
        </el-dialog>
        <!-- 6.0人工数据编辑框 end -->

        <!-- 5.0人工数据编辑框 -->
        <el-dialog title="编辑人工数据" :visible.sync="Rengongdialog50" width="60%" height="60%" :close-on-click-modal="false">
          <div class="rengongdata1">
            <div class="rengongdata2">
              <el-select v-model="speed50" placeholder="" style="width: 15%" class="rengongdata3">
                <el-option
                  v-for="item in speedlist" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="num50" placeholder="" style="width: 15%" class="rengongdata3">
                <el-option
                  v-for="item in numlist" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="rengongdata2" v-for="rgitem in Rengongdialog50list" :key="rgitem.index" v-if="rgitem.index >= 0">
              <el-select v-model="rgitem.rangeUp" placeholder="" style="width: 15%" class="rengongdata3">
                <el-option
                  v-for="item in qujianlist50" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="rgitem.rangeLow" placeholder="" style="width: 15%" class="rengongdata3">
                <el-option
                  v-for="item in qujianlist50" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-button type="text" @click="clickadd50(rgitem)">增加</el-button>
              <el-button v-if="rgitem.index > 0" type="text" @click="clickdelete50(rgitem)">删除</el-button>
            </div>
          </div>
          <el-button type="primary" @click="clicksave50">保存</el-button>
        </el-dialog>
        <!-- 5.0人工数据编辑框 end -->

    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      neizhitjgglist: [
        { value: '8', label: '无' },
        { value: '1', label: 'A' },
        { value: '2', label: 'B' },
        { value: '3', label: 'C' },
        { value: '4', label: 'D' },
        { value: '5', label: 'E' },
        { value: '6', label: 'F' },
        { value: '7', label: '其他' }
      ],
      xunlianneardegreelist: [
        { value: '0', label: '-5.0D' },
        { value: '1', label: '-4.5D' },
        { value: '2', label: '-4.0D' },
        { value: '3', label: '-3.5D' },
        { value: '4', label: '-3.0D' },
        { value: '5', label: '-2.5D' },
        { value: '6', label: '-2.0D' },
        { value: '7', label: '-1.5D' },
        { value: '8', label: '-1.0D' },
        { value: '9', label: '-0.5D' },
        { value: '10', label: '+0.0D' },
        { value: '11', label: '+0.5D' },
        { value: '12', label: '+1.0D' },
        { value: '13', label: '+1.5D' },
        { value: '14', label: '+2.0D' },
        { value: '15', label: '+2.5D' },
        { value: '16', label: '+3.0D' },
        { value: '17', label: '+3.5D' },
        { value: '18', label: '+4.0D' }
      ],
      xunlianfardegreelist: [
        { value: '0', label: '+3.0D' },
        { value: '1', label: '+2.5D' },
        { value: '2', label: '+2.0D' },
        { value: '3', label: '+1.5D' },
        { value: '4', label: '+1.0D' },
        { value: '5', label: '+0.5D' },
        { value: '6', label: '+0.0D' },
        { value: '7', label: '-0.5D' },
        { value: '8', label: '-1.0D' },
        { value: '9', label: '-1.5D' },
        { value: '10', label: '-2.0D' }
      ],
      TrainingDataChange: {},
      dialogAdd: false,
      // 选择机构
      select: {
        keywords: ''
      },
      radio: '1',
      trainingData: [],
      Rengongdialog60: false,
      Rengongdialog60list: [],
      qujianlist60: [],
      Rengongdialog50: false,
      Rengongdialog50list: [],
      qujianlist50: [
        { value: '417', label: '417' },
        { value: '401', label: '401' },
        { value: '376', label: '376' },
        { value: '351', label: '351' },
        { value: '326', label: '326' },
        { value: '301', label: '301' },
        { value: '276', label: '276' },
        { value: '251', label: '251' },
        { value: '226', label: '226' },
        { value: '201', label: '201' },
        { value: '176', label: '176' },
        { value: '151', label: '151' },
        { value: '126', label: '126' },
        { value: '101', label: '101' },
        { value: '76', label: '76' },
        { value: '51', label: '51' },
        { value: '26', label: '26' },
        { value: '1', label: '1' },
        { value: '-24', label: '-24' },
        { value: '-49', label: '-49' },
        { value: '-74', label: '-74' },
        { value: '-99', label: '-99' },
        { value: '-124', label: '-124' },
        { value: '-149', label: '-149' },
        { value: '-174', label: '-174' },
        { value: '-199', label: '-199' },
        { value: '-224', label: '-224' },
        { value: '-249', label: '-249' },
        { value: '-274', label: '-274' },
        { value: '-299', label: '-299' },
        { value: '-324', label: '-324' },
        { value: '-349', label: '-349' },
        { value: '-374', label: '-374' },
        { value: '-399', label: '-399' },
        { value: '-424', label: '-424' },
        { value: '-449', label: '-449' },
        { value: '-474', label: '-474' },
        { value: '-499', label: '-499' },
        { value: '-524', label: '-524' },
        { value: '-549', label: '-549' },
        { value: '-574', label: '-574' },
        { value: '-599', label: '-599' },
        { value: '-624', label: '-624' },
        { value: '-649', label: '-649' },
        { value: '-674', label: '-674' },
        { value: '-699', label: '-699' },
        { value: '-724', label: '-724' },
        { value: '-749', label: '-749' },
        { value: '-774', label: '-774' },
        { value: '-799', label: '-799' },
        { value: '-824', label: '-824' }
      ],
      speed50: 0,
      num50: 0,
      speedlist: [
        { value: '0', label: '0' },
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' },
        { value: '8', label: '8' },
        { value: '9', label: '9' },
        { value: '10', label: '10' }
      ],
      numlist: [
        { value: '5', label: '5' },
        { value: '10', label: '10' },
        { value: '15', label: '15' },
        { value: '20', label: '20' },
        { value: '30', label: '30' }
      ],
      parentdata: null
    }
  },
  mounted () {
    for (var i = 1000; i >= -2000; i -= 25) {
      this.qujianlist60.push({ value: i.toString(), label: i.toString() })
    }
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.apigetcustomerruledata()
    },
    backTrainingData () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apieditcustomerruledata()
    },
    clickadd60 (rgitem) {
      var buflist = []
      var addindex = 0
      for (var j = 0, len = this.Rengongdialog60list.length; j < len; j++) {
        var obj = this.Rengongdialog60list[j]
        var index = this.Rengongdialog60list[j].index
        obj.index += addindex
        buflist.push(obj)

        if (index == rgitem.index) {
          addindex = 1
          var obj2 = JSON.parse(JSON.stringify(obj))
          obj2.index += 1
          buflist.push(obj2)
        }
      }
      this.Rengongdialog60list = buflist
    },
    clickdelete60 (rgitem) {
      var buflist = []
      var addindex = 0
      for (var j = 0, len = this.Rengongdialog60list.length; j < len; j++) {
        var index = this.Rengongdialog60list[j].index
        if (index == rgitem.index) {
          addindex = -1
        } else {
          var obj = this.Rengongdialog60list[j]
          obj.index += addindex
          buflist.push(obj)
        }
      }
      this.Rengongdialog60list = buflist
    },
    clicksave60 () {
      this.Rengongdialog60list[0].rangeLow = this.Rengongdialog60list[1].num
      this.TrainingDataChange.Rengongdata = JSON.stringify(this.Rengongdialog60list)
      this.Rengongdialog60 = false
    },
    clickadd50 (rgitem) {
      var buflist = []
      var addindex = 0
      for (var j = 0, len = this.Rengongdialog50list.length; j < len; j++) {
        var obj = this.Rengongdialog50list[j]
        var index = this.Rengongdialog50list[j].index
        obj.index += addindex
        buflist.push(obj)

        if (index == rgitem.index) {
          addindex = 1
          var obj2 = JSON.parse(JSON.stringify(obj))
          obj2.index += 1
          buflist.push(obj2)
        }
      }
      this.Rengongdialog50list = buflist
    },
    clickdelete50 (rgitem) {
      var buflist = []
      var addindex = 0
      for (var j = 0, len = this.Rengongdialog50list.length; j < len; j++) {
        var index = this.Rengongdialog50list[j].index
        if (index == rgitem.index) {
          addindex = -1
        } else {
          var obj = this.Rengongdialog50list[j]
          obj.index += addindex
          buflist.push(obj)
        }
      }
      this.Rengongdialog50list = buflist
    },
    clicksave50 () {
      for (var j = 0, len = this.Rengongdialog50list.length; j < len; j++) {
        this.Rengongdialog50list[j].speed = this.speed50
        this.Rengongdialog50list[j].num = this.num50
      }
      this.TrainingDataChange.Rengongdata = JSON.stringify(this.Rengongdialog50list)
      this.Rengongdialog50 = false
    },
    clickedit () {
      var obj = JSON.parse(this.TrainingDataChange.Rengongdata)
      if (this.TrainingDataChange.Rengongdatatype == '1') {
        this.Rengongdialog50 = true
        this.Rengongdialog50list = obj
        this.speed50 = obj[1].speed
        this.num50 = obj[1].num
      }
      if (this.TrainingDataChange.Rengongdatatype == '2') {
        this.Rengongdialog60 = true
        this.Rengongdialog60list = obj
      }
    },
    apigetcustomerruledata: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getcustomerruledata, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.TrainingDataChange = response.data
            that.trainingData = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditcustomerruledata: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        righteyedegree: that.TrainingDataChange.Righteyedegree,
        lefteyedegree: that.TrainingDataChange.Lefteyedegree,
        rightcolumnmirror: that.TrainingDataChange.Rightcolumnmirror,
        leftcolumnmirror: that.TrainingDataChange.Leftcolumnmirror,
        rengongdata: that.TrainingDataChange.Rengongdata,
        rengongstate: that.TrainingDataChange.Rengongstate,
        dzrangeup: that.TrainingDataChange.Dzrangeup,
        dzrangelow: that.TrainingDataChange.Dzrangelow,
        dznum: that.TrainingDataChange.Dznum,
        dzspeed: that.TrainingDataChange.Dzspeed,
        dzstate: that.TrainingDataChange.Dzstate,
        diopterstate: that.TrainingDataChange.Diopterstate,
        addtype: that.TrainingDataChange.Addtype,
        eyemode: that.TrainingDataChange.Eyemode,
        xunlianmode: that.TrainingDataChange.Xunlianmode,
        xunlianneardegree: that.TrainingDataChange.Xunlianneardegree,
        xunlianfardegree: that.TrainingDataChange.Xunlianfardegree,
        neizhitjggright: that.TrainingDataChange.Neizhitjggright,
        neizhitjggleft: that.TrainingDataChange.Neizhitjggleft,
        minirulestatus: that.TrainingDataChange.Minirulestatus,
        minirulen: that.TrainingDataChange.Minirulen,
        minirulex: that.TrainingDataChange.Minirulex,
        miniruleh1: that.TrainingDataChange.Miniruleh1,
        miniruleh2: that.TrainingDataChange.Miniruleh2,
        beizhu: that.TrainingDataChange.Beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editcustomerruledata, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.apigetcustomerruledata()
          }
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}

.rengongdata1 {
  padding-bottom: 20px;
}

.rengongdata2 {
  padding-bottom: 5px;
}

.rengongdata3 {
  padding-right: 5px;
}

.box-card-sub {
  width: 600px;
  margin-bottom: 5px;
}
</style>
